import PropTypes from "prop-types";
import { Timestamp } from "firebase/firestore";
import { formatFirestoreTimeStamp } from "utils";

import { MatchTypes } from "enums/matchType";

export default function HeaderTitle({ date, matchTypeName, title, bets }) {
  const { matchType: kickerBetMatchType } = bets ?? [];

  const dateStr = formatFirestoreTimeStamp(date, "EEE, MMM dd");

  return (
    <div className="common-header--title-container">
      <div className="common-header--title-date">{title || dateStr}</div>
      <div className="common-header--title-desc">
        {matchTypeName && matchTypeName}
        {kickerBetMatchType >= 0 && ` + ${MatchTypes[kickerBetMatchType]}`}
      </div>
    </div>
  );
}

HeaderTitle.propTypes = {
  bets: PropTypes.shape({
    matchType: PropTypes.number,
    stake: PropTypes.number,
  }),

  date: PropTypes.instanceOf(Timestamp),
  matchTypeName: PropTypes.string,

  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

HeaderTitle.defaultProps = {
  date: Timestamp.now(),
  matchTypeName: null,

  title: null,
  bets: null,
};
